export default __webpack_public_path__ + "static/media/YAS0910.34I-41428_-24745_0.dd00e5b9.jpg";